"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorRFPReminder = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.VendorRFPReminder = typebox_1.Type.Object({
    access_link: typebox_1.Type.String(),
    vendor_name: typebox_1.Type.String(),
    first_name: typebox_1.Type.Optional(typebox_1.Type.String()),
    clean_location: typebox_1.Type.Optional(typebox_1.Type.String()),
    proposal_number: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * Formatted as EEE MM/dd/yy hh:mm aaa
     */
    deadline: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * Formatted as EEE MM/dd/yy
     */
    start_date: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=vendor-rfp-reminder.js.map